export default "__VITE_ASSET__fQwep7oPWon_jDlR2IoL7Q__"